import { render, staticRenderFns } from "./WorkSkillsDialog.vue?vue&type=template&id=0a786544&"
import script from "./WorkSkillsDialog.vue?vue&type=script&lang=js&"
export * from "./WorkSkillsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports